import { render, staticRenderFns } from "./PayingOrders.vue?vue&type=template&id=2bc7b0de&"
import script from "./PayingOrders.vue?vue&type=script&lang=js&"
export * from "./PayingOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports